import * as React from 'react';
import ApplicationContainer from '../Application/Application.container';
import BookingOfferDetails from './BookingOfferDetails';
import { IBookingOfferDetailsProps } from './BookingOfferDetails.interfaces';

/**
 * Shows hotel and offer detals at the top of the booking page.
 */
function BookingOfferDetailsPage(props: IBookingOfferDetailsProps) {
  return (
    <ApplicationContainer
      territory={props.territory}
      userTerritory={props.userTerritory}
      affiliate={props.affiliate.urlString}
      currency={props.currency}
      apiUrl={props.apiUrl}
      theme={props.theme}
      translationObject={props.translationObject}
      isOpenSite={props.affiliate.isOpenSite}
      userId={props.userId}
    >
      <BookingOfferDetails {...props} />
    </ApplicationContainer>
  );
}

export default BookingOfferDetailsPage;
